import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IEmail } from '../interfaces/email-template';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class EmailService extends EditService<null, null> {
  url = '/api/emailsender';
  entityTitle = '';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  sendEmail(email: IEmail) {
    //return this.http.post('/api/emailsender', email).toPromise();
    let successMsg = 'You will receive an e-mail.';

    return this.handleRequest(
      this.http.post('/api/emailsender', email),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }

  sendTestEmail() {
    //return this.http.get('/api/emailsender/testemail').toPromise();
    return this.handleRequest(
      this.http.get('/api/emailsender/testemail'),
      this.handlersFactory.getDefault(),
    );
  }
}
